import React from "react";
import {
	Box,
	Button,
	IconButton,
	inputBaseClasses,
	Stack,
	Typography,
} from "@mui/material";
import { Field } from "@onair/minimal-ui/hook-form";
import { Iconify } from "@onair/minimal-ui/iconify";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useFieldArray, UseFormReturn } from "react-hook-form";
import { WizardSchemaType } from "../../index";

interface Props {
	methods: UseFormReturn<WizardSchemaType>;
}

const FAQContent = ({ methods }: Props) => {
	const { control, watch, setValue } = methods;

	const { fields, append, remove } = useFieldArray({
		control,
		name: "stepResource.qas",
	});

	return (
		<Stack spacing={2}>
			<Typography variant="caption" color="text.secondary">
				Trả lời các câu hỏi mà người dùng có thể biết thêm về sự kiện, chẳng hạn
				như điều kiện tham gia, giá trị sự kiện mang lại, thiết bị cần chuẩn bị.
			</Typography>
			{fields.map((field, index) => {
				return (
					<Box p={2} bgcolor="grey.100" borderRadius={2} key={field.id}>
						<Stack spacing={2}>
							<Stack
								direction="row"
								justifyContent="space-between"
								alignItems="center"
							>
								<Stack direction="row" spacing={2}>
									<Box
										borderLeft="4px solid"
										borderColor="primary.main"
										sx={{
											borderRadius: 100,
										}}
									></Box>
									<Typography variant="subtitle2">Câu {index + 1}</Typography>
								</Stack>

								<IconButton
									size="small"
									color="error"
									onClick={() => remove(index)}
								>
									<DeleteForeverIcon />
								</IconButton>
							</Stack>
							<Stack direction="column" spacing={2}>
								<Field.Text
									sx={{
										[`& .${inputBaseClasses.root}`]: {
											backgroundColor: "white",
										},
									}}
									name={`stepResource.qas.${index}.question`}
									label="Câu hỏi"
								/>

								<Field.Text
									sx={{
										[`& .${inputBaseClasses.root}`]: {
											backgroundColor: "white",
										},
									}}
									name={`stepResource.qas.${index}.answer`}
									label="Câu trả lời"
									rows={3}
									multiline
								/>
							</Stack>
						</Stack>
					</Box>
				);
			})}

			<Stack
				justifyContent="space-between"
				spacing={1.5}
				alignItems="center"
				direction="row"
			>
				<Box width="35%" height="1px" bgcolor="rgba(0, 80, 255, 0.48)" />
				<Button
					variant="outlined"
					color="primary"
					sx={{
						borderRadius: 100,
						flexGrow: 1,
						width: "40%",
					}}
					onClick={() =>
						append({
							question: "",
							answer: "",
						})
					}
					startIcon={<Iconify icon="eva:plus-circle-outline" width={20} />}
				>
					Thêm mới
				</Button>
				<Box width="35%" height="1px" bgcolor="rgba(0, 80, 255, 0.48)" />
			</Stack>
		</Stack>
	);
};

export default FAQContent;
